import { atom } from 'recoil';

export const tokenStateAtom = atom<string | undefined>({
  key: 'tokenState',
  default: undefined,
});
